import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRecBtn = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={43} height={42} fill='none' {...props}>
    <circle cx={21.5} cy={21} r={16} fill='#fff' />
    <circle cx={21.5} cy={21} r={19.5} stroke='#fff' strokeWidth={3} />
  </svg>
);
export default SvgRecBtn;
